
import { useStore } from 'vuex';
import { onBeforeMount, ref } from '@vue/runtime-core';
import { defineComponent } from 'vue';
import { onBeforeRouteUpdate } from 'vue-router';

export default defineComponent({
    components: {},
    setup() {
        // 获取vuex对象
        const store = useStore();
        const transitionName = ref('slide-left');

        onBeforeMount(() => {
            console.log('获取用户信息');
            // 获取用户信息
            store.dispatch('user/USER_INFO');

            // 获取用户设置
            const userGUID = store.state.user.userInfo.UserGUID;
            const paramsUserSettings = {
                userId: userGUID,
            };
            store.dispatch('user/USER_SETTINGS', paramsUserSettings);
        });
        // 页面切换过度
        onBeforeRouteUpdate((to: any, from: any) => {
            if (to.meta.index > from.meta.index) {
                transitionName.value = 'slide-left';
            } else if (to.meta.index < from.meta.index) {
                transitionName.value = 'slide-right';
            } else {
                transitionName.value = '';
            }
        });
        return { transitionName };
    },
});
